import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const WWW_HOST = 'www.test-alberta-class7.vercel.app';
const CANONICAL_HOST = 'test-alberta-vercel.app';

if (window.location.hostname.startsWith("www.")) {
  const newHost = window.location.hostname.replace(/^www\./, "");
  const newUrl = `${window.location.protocol}//${newHost}${window.location.pathname}${window.location.search}`;
  window.location.replace(newUrl); // Redirect without keeping history
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
